import gql from 'graphql-tag';

export const PEOPLE_TIMESHEET_FRAGMENT = gql`
	fragment peopleTimesheet on Timesheet {
		id
		date
		startMinutes
		endMinutes
		breakMinutes
		breakMinutesAutomatic
		status
		statusLabel
		approvedAt
		notes
		discardComment
		xeroTimesheetId
		xeroTimesheetLineId
		xeroSyncedAt
		editHistoryCount
		employee {
			id
			firstName
			lastName
			preferredName
			personalEmail
			employmentType
			workTenant {
				id
				name
			}
		}
		rosterShift {
			id
			startMinutes
			endMinutes
			area
			areaLabel
		}
		sourceClockInEvent {
			id
			capturedAt
			photoLink
		}
		sourceClockOutEvent {
			id
			capturedAt
			photoLink
		}
		approvedBy {
			id
			firstname
			lastname
		}
	}
`;

export const GET_TIMESHEETS = gql`
	query(
		$page: Int,
		$perPage: Int,
		$sortBy: String!,
		$sortDirection: Int!,
		$filter: TimesheetFilter
	) {
		getTimesheets(
			page: $page,
			perPage: $perPage,
			sortBy: $sortBy,
			sortDirection: $sortDirection,
			filter: $filter
		) {
			items {
				...peopleTimesheet
			}
			count
		}
	}
	${PEOPLE_TIMESHEET_FRAGMENT}
`;

export const GET_TIMESHEET_EMPLOYEES = gql`
	query($filter: TimesheetFilter) {
		getTimesheetEmployees(filter: $filter) {
			id
			firstName
			lastName
			preferredName
			personalEmail
			status
			noTimesheetsToApprove
			workTenant {
				id
				name
			}
		}
	}
`;

export const GET_MY_TIMESHEETS = gql`
	query($fromDate: String, $toDate: String) {
		getMyTimesheets(fromDate: $fromDate, toDate: $toDate) {
			...peopleTimesheet
		}
	}
	${PEOPLE_TIMESHEET_FRAGMENT}
`;

export const GET_MY_TIMESHEETS_PAGE = gql`
	query($page: Int, $perPage: Int) {
		getMyTimesheetsPage(page: $page, perPage: $perPage) {
			items {
				...peopleTimesheet
			}
			count
		}
	}
	${PEOPLE_TIMESHEET_FRAGMENT}
`;

export const GET_MY_PAY_CYCLE_HOURS = gql`
	query getMyPayCycleHours($date: String) {
		getMyPayCycleHours(date: $date) {
			startDate
			endDate
			roundedNetWorkedHours
		}
	}
`;

export const GET_TIMESHEET_TOTALS = gql`
	query($filter: TimesheetFilter) {
		getTimesheetTotals(filter: $filter) {
			count
			breakMinutes
			roundedNetWorkedHours
			netWorkedMinutes
			varianceMinutes
		}
	}
`;

export const GET_TIMESHEET_PAY_CYCLES = gql`
	query getTimesheetPayCycles($date: String) {
		getTimesheetPayCycles(date: $date) {
			calendarName
			current {
				startDate
				endDate
			}
			previous {
				startDate
				endDate
			}
			beforePrevious {
				startDate
				endDate
			}
		}
	}
`;

export const GET_TIMESHEET_SUMMARIES = gql`
	query getTimesheetSummaries(
		$page: Int,
		$perPage: Int,
		$sortBy: String,
		$sortDirection: Int,
		$filter: TimesheetFilter
	) {
		getTimesheetSummaries(
			page: $page,
			perPage: $perPage,
			sortBy: $sortBy,
			sortDirection: $sortDirection,
			filter: $filter
		) {
			items {
				id
				employee {
					id
					firstName
					lastName
					preferredName
					employmentType
					workTenant {
						id
						name
					}
				}
				rosteredMinutes
				workedMinutes
				varianceMinutes
				longestShiftMinutes
				previousCycleWorkedMinutes
				twoCycleWorkedMinutes
			}
			count
		}
	}
`;

export const GET_TIMESHEET_EDIT_HISTORY = gql`
	query getTimesheetEditHistory($timesheetId: ID!) {
		getTimesheetEditHistory(
			timesheetId: $timesheetId,
			page: 0,
			perPage: 8,
			sortDirection: -1
		) {
			items {
				id
				created
				content
				creator {
					id
					firstname
					lastname
				}
			}
			count
		}
	}
`;

export const CREATE_MANAGER_TIMESHEET = gql`
	mutation createManagerTimesheet($input: CreateManagerTimesheetInput!) {
		createManagerTimesheet(input: $input) {
			...peopleTimesheet
		}
	}
	${PEOPLE_TIMESHEET_FRAGMENT}
`;

export const MODIFY_TIMESHEET = gql`
	mutation modifyTimesheet($input: ModifyTimesheetInput!) {
		modifyTimesheet(input: $input) {
			...peopleTimesheet
		}
	}
	${PEOPLE_TIMESHEET_FRAGMENT}
`;

export const APPROVE_TIMESHEETS = gql`
	mutation approveTimesheets($ids: [ID!]!) {
		approveTimesheets(ids: $ids) {
			...peopleTimesheet
		}
	}
	${PEOPLE_TIMESHEET_FRAGMENT}
`;

export const UNAPPROVE_TIMESHEETS = gql`
	mutation unapproveTimesheets($ids: [ID!]!) {
		unapproveTimesheets(ids: $ids) {
			...peopleTimesheet
		}
	}
	${PEOPLE_TIMESHEET_FRAGMENT}
`;

export const DISCARD_TIMESHEET = gql`
	mutation discardTimesheet($id: ID!, $comment: String) {
		discardTimesheet(id: $id, comment: $comment) {
			...peopleTimesheet
		}
	}
	${PEOPLE_TIMESHEET_FRAGMENT}
`;

export const DESTROY_TIMESHEET = gql`
	mutation destroyTimesheet($id: ID!) {
		destroyTimesheet(id: $id)
	}
`;
